import React from "react";
import ReservationsTable from "./child/ReservationsTable";

const ReservationsLayer = () => {
  return (
    <section className="row gy-4 mt-1">
      <div className="col-12">
        <ReservationsTable />
      </div>
    </section>
  );
};

export default ReservationsLayer;
